import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class MicrosoftApiErrorLog extends MongoEntity {
  static override _class = 'MicrosoftApiErrorLog';
  static override _collectionName = 'microsoft-api-error-log';

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;

  @Field(type => String)
  message: Maybe<string>;

  @Field(type => String)
  code: Maybe<string>;

  @Field(type => String)
  url: Maybe<string>;

  @Field(type => String)
  method: Maybe<string>;

  @Field(type => String)
  data: Maybe<string>;
}
